import React from 'react'
import PropTypes from 'prop-types'
import FacebookIcon from 'images/suppliers/facebook.png'
import LinkedinIcon from 'images/suppliers/linkedin.png'

export interface LinkProps {
  platform: 'facebook' | 'linkedin'
}

export const SocialLink = ({ platform }: LinkProps): React.ReactElement => {
  const iconFor = (): string => {
    switch (platform) {
      case 'facebook':
        return FacebookIcon
      case 'linkedin':
        return LinkedinIcon
    }
  }

  return (
    <img src={iconFor()} className='social-link' alt={platform + ' logo'} />
  )
}

SocialLink.propTypes = {
  platform: PropTypes.string.isRequired
}
